// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iO_G_"};